<template>
  <div id="appRoot" style="background-color: #EFEFEF">
    <template v-if="!$route.meta.public && !checador">
      <v-app id="inspire" style="background-color: #EFEFEF">
        <v-content id="v-content" >
          <template v-if="rol == 'root' || rol == 'admin-sucursal' || rol == 'admin-depto' || rol == 'empleado'">
            <ck-toolbar id="ck-toolbar" v-show="isLoggedIn" :notification="notification" />
            <menu-drawer :isOpen="true" width="290" v-show="isLoggedIn" />
          </template>

          <template v-if="rol == 'admin' || rol == 'admin-empresa'">
            <ck-toolbar v-if="!primera_vez" id="ck-toolbar" v-show="isLoggedIn" :notification="notification" />
            <menu-drawer v-if="!primera_vez" :isOpen="true" width="290" v-show="isLoggedIn" />
          </template>

          <!-- <app-toolbar id="app-toolbar" class="app--toolbar" v-show="isLoggedIn" :notification="notification"></app-toolbar> -->
          <!-- <menu-drawer v-if="!primera_vez" :isOpen="true" width="250" v-show="isLoggedIn" /> -->
          <div class="page-wrapper">
            <router-view @setNotifications="setNotifications" @comportamiento="comportamiento"></router-view>
          </div>   
        </v-content>
        <app-fab></app-fab>
        <!-- <modals-container/> -->
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view
            :key="$route.fullpath"
            @loggedIn="loggedIn"
          ></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
//import AppMenu from "@/components/AppMenu";
import MenuDrawer from '@/components/MenuDrawer';
import AppToolbar from "@/components/AppToolbar";
import CkToolbar from "@/components/CkToolbar";
import AppFab from "@/components/AppFab";
import PageHeader from "@/components/PageHeader";
import { mapActions, mapState } from "vuex";
import AppEvents from "./event";

export default {
  name: 'App',
  components: {
    //AppMenu,
    MenuDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
    CkToolbar
  },
  data: () => ({
    isLoggedIn: false,
    expanded: true,
    primera_vez: true,
    checador : false,
    snackbar: {
      show: false,
      text: "",
      color: ""
    },
    notification: [],
    datosUsuario: null,
    rol         : null,
  }),
  computed: {
    ...mapState("auth", ["error", "errorMessage", "datos", "menu", "isLogged"])
  },
  updated() {
    if (this.$session.get("usuario") != undefined) {
      var datosLogin = this.$session.get("usuario");

      this.datosUsuario = this.$session.get("usuario");
      this.rol = this.datosUsuario.rol.name;

      if(datosLogin.rol.name == "checador"){
        this.checador = true;
      }else{
        this.checador = false;
      }
    }
  },
  created() {
    if (this.$session.get("usuario") != undefined) {
      var datosLogin = this.$session.get("usuario");
      this.primera_vez = datosLogin.configuracion;

      this.datosUsuario = this.$session.get("usuario");
      this.rol = this.datosUsuario.rol.name;

      if(datosLogin.rol.name == "checador"){
        this.checador = true;
      }else{
        this.checador = false;
      }

      if (this.primera_vez) {
        this._updateUserData();
      }
    }

    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
    this.isLoggedIn = this.$session.get("usuario") != undefined ? true : false;
  },
  methods: {
    ...mapActions("auth", ["updateUserData"]),
    async _updateUserData() {
      var datosLogin = this.$session.get("usuario");
      var data = {
        usuario_id: datosLogin.id,
        sistema: 'gdth'
      };

      await this.updateUserData(data);

      if (!this.error) {
        this.$session.destroy();

        this.$session.set("usuario", this.datos);
        this.$session.set("menu", this.menu);
      }
    },
    comportamiento(value) {
      this.$emit("closeMenu");
      this.primera_vez = value;
    },
    loggedIn() {
      this.isLoggedIn = true;
    },
    setNotifications(data) {
      if (data.length > 0) {
        this.notification = data;
      }
    }
  }
};
</script>

<style scoped>
  .setting-fab{
    top:50%!important;
    right:0;
    border-radius:0
  }
  .page-wrapper {
    min-height:calc(100vh - 64px - 50px - 81px );
  }
</style>
